import { CurrentResponse } from "./state";
import {
  ResponseTypes,
  ProposalArtwork,
  PayloadArtwork,
  ProposalPlanDecoration,
  PayloadPlanDecoration,
  AttachFile
} from "../projects";

export const SET_CURRENT_RESPONSES = "SET_CURRENT_RESPONSES";
export const SET_CURRENT_PROPOSAL_RESPONSE_POV =
  "SET_CURRENT_PROPOSAL_RESPONSE_POV";
export const REMOVE_CURRENT_PROPOSAL_RESPONSE =
  "REMOVE_CURRENT_PROPOSAL_RESPONSE";
export const ADD_OR_REPLACE_COMMENT_FOR_ARTWORK =
  "ADD_OR_REPLACE_COMMENT_FOR_ARTWORK";
export const REMOVE_COMMENT_FOR_ARTWORK = "REMOVE_COMMENT_FOR_ARTWORK";
export const SET_CURRENT_PROPOSAL_RESPONSE_PAYLOAD_ARTWORK =
  "SET_CURRENT_PROPOSAL_RESPONSE_PAYLOAD_ARTWORK";
export const SET_CURRENT_PROPOSAL_RESPONSE_PLAN_DECORATION =
  "SET_CURRENT_PROPOSAL_RESPONSE_PLAN_DECORATION";
export const ADD_CURRENT_ARTWORK_RESPONSE = "ADD_CURRENT_ARTWORK_RESPONSE";
export const ADD_CURRENT_PLAN_DECORATION_RESPONSE =
  "ADD_CURRENT_PLAN_DECORATION_RESPONSE";
export const ADD_CURRENT_POV_RESPONSE = "ADD_CURRENT_POV_RESPONSE";
export const SET_CURRENT_PROPOSAL_RESPONSE_TYPE =
  "SET_CURRENT_PROPOSAL_RESPONSE_TYPE";

export function setCurrentResponses(currentResponses: CurrentResponse[]) {
  return {
    type: SET_CURRENT_RESPONSES as typeof SET_CURRENT_RESPONSES,
    currentResponses
  };
}
export function setCurrentProposalResponseForPov(
  proposalUuid: string,
  ressourceId: number,
  comment: string
) {
  return {
    type: SET_CURRENT_PROPOSAL_RESPONSE_POV as typeof SET_CURRENT_PROPOSAL_RESPONSE_POV,
    proposalUuid,
    ressourceId,
    comment
  };
}
export function setCurrentProposalResponseForArtwork(
  proposalUuid: string,
  id: string,
  x: number,
  y: number,
  text: string,
  files: AttachFile[]
) {
  return {
    type: ADD_OR_REPLACE_COMMENT_FOR_ARTWORK as typeof ADD_OR_REPLACE_COMMENT_FOR_ARTWORK,
    proposalUuid,
    id,
    x,
    y,
    text,
    files
  };
}
export function removeCommentFromArtworkProposal(
  proposalUuid: string,
  commentId: string
) {
  return {
    type: REMOVE_COMMENT_FOR_ARTWORK as typeof REMOVE_COMMENT_FOR_ARTWORK,
    proposalUuid,
    commentId
  };
}
export function setCurrentProposalResponseType(
  proposalUuid: string,
  responseType: ResponseTypes
) {
  return {
    type: SET_CURRENT_PROPOSAL_RESPONSE_TYPE as typeof SET_CURRENT_PROPOSAL_RESPONSE_TYPE,
    proposalUuid,
    responseType
  };
}
export function setCurrentProposalResponsePayloadForArtwork(
  proposalUuid: string,
  payload: PayloadArtwork
) {
  return {
    type: SET_CURRENT_PROPOSAL_RESPONSE_PAYLOAD_ARTWORK as typeof SET_CURRENT_PROPOSAL_RESPONSE_PAYLOAD_ARTWORK,
    proposalUuid,
    payload
  };
}
export function setCurrentProposalResponseForPlanDecoration(
  proposalUuid: string,
  ressourceId: number,
  payload: PayloadPlanDecoration
) {
  return {
    type: SET_CURRENT_PROPOSAL_RESPONSE_PLAN_DECORATION as typeof SET_CURRENT_PROPOSAL_RESPONSE_PLAN_DECORATION,
    proposalUuid,
    ressourceId,
    payload
  };
}
export function removeCurrentProposalResponse(proposalUuid: string) {
  return {
    type: REMOVE_CURRENT_PROPOSAL_RESPONSE as typeof REMOVE_CURRENT_PROPOSAL_RESPONSE,
    proposalUuid
  };
}
export function createEmptyArtworkResponse(proposal: ProposalArtwork) {
  return {
    type: ADD_CURRENT_ARTWORK_RESPONSE as typeof ADD_CURRENT_ARTWORK_RESPONSE,
    proposal
  };
}
export function createEmptyPovResponse(proposalUuid: string) {
  return {
    type: ADD_CURRENT_POV_RESPONSE as typeof ADD_CURRENT_POV_RESPONSE,
    proposalUuid
  };
}

export function createEmptyPlanDecorationResponse(
  proposal: ProposalPlanDecoration
) {
  return {
    type: ADD_CURRENT_PLAN_DECORATION_RESPONSE as typeof ADD_CURRENT_PLAN_DECORATION_RESPONSE,
    proposal
  };
}
export type Actions =
  | ReturnType<typeof setCurrentResponses>
  | ReturnType<typeof setCurrentProposalResponseForPov>
  | ReturnType<typeof removeCurrentProposalResponse>
  | ReturnType<typeof setCurrentProposalResponseForArtwork>
  | ReturnType<typeof setCurrentProposalResponsePayloadForArtwork>
  | ReturnType<typeof createEmptyArtworkResponse>
  | ReturnType<typeof createEmptyPlanDecorationResponse>
  | ReturnType<typeof setCurrentProposalResponseForPlanDecoration>
  | ReturnType<typeof setCurrentProposalResponseType>
  | ReturnType<typeof createEmptyPovResponse>
  | ReturnType<typeof removeCommentFromArtworkProposal>;



// WEBPACK FOOTER //
// ./src/redux/currentResponses/actions.ts